var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegmentSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 78,
    viewBox: "0 0 52 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1105 0V7.28818C50.3297 7.30677 49.5583 7.35325 48.7868 7.40903C26.0339 9.26826 8.06763 28.0279 7.45419 51.1102V51.1753C7.4449 51.51 7.4356 51.8353 7.4356 52.17V52.4861C7.4356 52.8207 7.4356 53.1647 7.45419 53.4993C7.45419 53.8898 7.47278 54.2709 7.49137 54.6614C7.50996 55.0425 7.52855 55.4236 7.56573 55.8048C7.58431 56.1859 7.62149 56.5671 7.66796 56.9482C8.16057 62.0797 9.54545 67.0903 11.739 71.7291L11.7947 71.7012C12.1293 72.4077 12.4918 73.1049 12.8543 73.7928L6.35744 77.5392C5.97637 76.8513 5.62317 76.1633 5.28857 75.4568C1.82172 68.336 0 60.4714 0 52.4861C0 24.7835 21.5632 2.02656 48.7868 0.12085C49.5583 0.0557769 50.3297 0.0185923 51.1105 0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentSm);
export default __webpack_public_path__ + "static/media/segment-sm.f4c9bab8.svg";
export { ForwardRef as ReactComponent };